import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link, useNavigate } from "react-router-dom";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import usePrivateLink from "../config/usePrivateLink";
import "./StudentReport.css";
import { Bar, Line } from "react-chartjs-2";
import { studentDashboardReport } from "../../api/StudentServices";
import Master from "./Master";
import DashboardModal from "./components/DashboardModal";
import { formatToDate } from "../master/FormatToDateTime";

export default function StudentsReport() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState("");
  const hasAccess = usePrivateLink();
  const [sessions, setSessions] = useState([]);
  const [data, setData] = useState({});
  const [filters, setFilters] = useState({});
  const [allFilters, setAllFilters] = useState({});

  const att = data?.today_attendance || {};

  const present = Number(att?.present || 0);
  const absent = Number(att?.absent || 0);
  const low = Number(att?.low_attendance || 0);

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) return prev;
      return {
        ...prev,
        session_id: activeSession,
      };
    });
  }, [sessions]);

  useEffect(() => {
    if (filters?.session_id) {
      getDashboard();
    }
  }, [filters]);

  const getDashboard = async () => {
    setLoading(true);
    try {
      const url = `session_id=${filters?.session_id ?? ""}`;

      const response = await studentDashboardReport(url);

      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const totalStudents =
    data?.batch_wise?.reduce(
      (sum, item) => sum + Number(item.total_student || 0),
      0,
    ) || 0;

  const totalBoys =
    data?.batch_wise?.reduce((sum, item) => sum + Number(item.male || 0), 0) ||
    0;

  const totalGirls =
    data?.batch_wise?.reduce(
      (sum, item) => sum + Number(item.female || 0),
      0,
    ) || 0;

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="dashboard-header-card mb-4">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div className="dashboard-header-icon">
                            <i className="ri-graduation-cap-line"></i>
                          </div>

                          <div>
                            <h3 className="fw-bold mb-1">Student Dashboard</h3>

                            <div className="text-body-secondary">
                              Academic Reports • Attendance • Admission
                              Analytics
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          {filters.session_id && (
                            <span className="badge rounded-pill bg-primary-subtle text-primary px-3 py-2">
                              <i className="ri-calendar-line me-1"></i>

                              {
                                sessions.find((s) => s.id == filters.session_id)
                                  ?.session
                              }
                            </span>
                          )}

                          {hasAccess("/student/add") && (
                            <Link to="/student/add" className="btn btn-primary">
                              <i className="ri-add-line me-1"></i>
                              Add Student
                            </Link>
                          )}

                          <button
                            className="btn btn-outline-primary"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#filterCanvas"
                          >
                            <i className="ri-filter-3-line me-1"></i>
                            Filters
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card-body">
                      <div className=" mb-4 ">
                        <h6 className="fw-bold mb-3">Student Overview</h6>

                        <div className="row g-3">
                          <div
                            className="col"
                            data-bs-toggle="modal"
                            data-bs-target="#MainModal"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setAllFilters({
                                ...filters,
                                table: "student",
                                type: "all",
                              })
                            }
                          >
                            <div className="simple-card border-primary">
                              <small className="text-muted fw-bold">
                                Total Students
                              </small>
                              <h4 className="text-primary m-0">
                                {data?.summary?.total}
                                {/* {data?.summary?.active +
                                  data?.summary?.inactive} */}
                              </h4>
                            </div>
                          </div>

                          <div
                            className="col"
                            data-bs-toggle="modal"
                            data-bs-target="#MainModal"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setAllFilters({
                                ...filters,
                                table: "student",
                                type: "active",
                              })
                            }
                          >
                            <div className="simple-card border-success">
                              <small className="text-muted fw-bold">
                                Active
                              </small>
                              <h4 className="text-success m-0">
                                {data?.summary?.active}
                              </h4>
                            </div>
                          </div>

                          <div
                            className="col"
                            data-bs-toggle="modal"
                            data-bs-target="#MainModal"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setAllFilters({
                                ...filters,
                                table: "student",
                                type: "inactive",
                              })
                            }
                          >
                            <div className="simple-card border-success-emphasis">
                              <small className="text-muted fw-bold">
                                Inactive
                              </small>
                              <h4 className="text-success-emphasis m-0">
                                {data?.summary?.inactive}
                              </h4>
                            </div>
                          </div>

                          <div
                            className="col"
                            data-bs-toggle="modal"
                            data-bs-target="#MainModal"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setAllFilters({
                                ...filters,
                                table: "student",
                                start_date: formatToDate(
                                  new Date(
                                    new Date().setDate(
                                      new Date().getDate() - 7,
                                    ),
                                  ),
                                ),
                              })
                            }
                          >
                            <div className="simple-card border-danger">
                              <small className="text-muted fw-bold">
                                New Admissions(7 Day){" "}
                              </small>
                              <h4 className="text-danger m-0">
                                {data?.summary?.new_admission}
                              </h4>
                            </div>
                          </div>

                          <div
                            className="col"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(
                                `/students/rte?session_id=${
                                  filters?.session_id ?? ""
                                }`,
                              )
                            }
                          >
                            <div className="simple-card border-purple">
                              <small className="text-muted fw-bold">
                                RTE Students
                              </small>
                              <h4 className="text-purple m-0">
                                {data?.summary?.rte_students}
                              </h4>
                            </div>
                          </div>
                          <div className="col">
                            <div className="simple-card border-purple">
                              <small className="text-muted fw-bold">
                                Total Batch
                              </small>
                              <h4 className="text-purple m-0">
                                {data?.summary?.total_batch}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row g-3">
                            <div className="col-md-12">
                              <div
                                className="card shadow-sm border-0"
                                style={{
                                  borderRadius: "16px",
                                  padding: "16px",
                                }}
                              >
                                <div className="d-flex justify-content-between mb-3">
                                  <h6 className="fw-bold m-0">
                                    🏫 Batch-wise Students
                                  </h6>
                                </div>

                                <div style={{ height: 260 }}>
                                  <Line
                                    data={{
                                      labels: data?.batch_wise?.map(
                                        (b) => b?.batch_name,
                                      ),

                                      datasets: [
                                        {
                                          label: "Total",
                                          data: data?.batch_wise?.map(
                                            (b) => b?.total_student,
                                          ),
                                          borderColor: "#7c3aed",
                                          backgroundColor:
                                            "rgba(124,58,237,0.15)",
                                          fill: true,
                                          tension: 0.5,
                                          pointRadius: 2,
                                          borderWidth: 1,
                                        },
                                        {
                                          label: "Boys",
                                          data: data?.batch_wise?.map(
                                            (b) => b?.male,
                                          ),
                                          borderColor: "#ef4444",
                                          backgroundColor:
                                            "rgba(239,68,68,0.15)",
                                          fill: true,
                                          tension: 0.5,
                                          pointRadius: 2,
                                          borderWidth: 1,
                                        },
                                        {
                                          label: "Girls",
                                          data: data?.batch_wise?.map(
                                            (b) => b?.female,
                                          ),
                                          borderColor: "#3b82f6",
                                          backgroundColor:
                                            "rgba(59,130,246,0.15)",
                                          fill: true,
                                          tension: 0.5,
                                          pointRadius: 2,
                                          borderWidth: 1,
                                        },
                                      ],
                                    }}
                                    options={{
                                      maintainAspectRatio: false,

                                      interaction: {
                                        mode: "index",
                                        intersect: false,
                                      },

                                      plugins: {
                                        legend: {
                                          position: "top",
                                        },

                                        tooltip: {
                                          backgroundColor: "#111",
                                          padding: 10,
                                          displayColors: true,

                                          callbacks: {
                                            label: (ctx) =>
                                              `${ctx.dataset.label}: ${ctx.raw}`,
                                          },
                                        },
                                      },

                                      scales: {
                                        x: {
                                          grid: { display: false },
                                        },
                                        y: {
                                          beginAtZero: true,
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row g-3 mt-2">
                            <div className="col-md-12">
                              <div
                                className="card shadow-sm border-0 h-100"
                                style={{
                                  borderRadius: "16px",
                                  padding: "16px",
                                }}
                              >
                                <h6 className="fw-bold mb-3">
                                  📊 Admission Insights
                                </h6>

                                {/* 🔷 STATS */}

                                {/* 🔷 GRAPH */}
                                <div style={{ height: 220 }}>
                                  <Line
                                    data={{
                                      labels: data?.month_wise_admission?.map(
                                        (m) => m?.month,
                                      ),

                                      datasets: [
                                        {
                                          label: "Total",
                                          data: data?.month_wise_admission?.map(
                                            (m) => Number(m?.total || 0),
                                          ),
                                          borderColor: "#7c3aed",
                                          backgroundColor:
                                            "rgba(124,58,237,0.08)",
                                          fill: true,
                                          tension: 0.4,
                                          pointRadius: 2,
                                          borderWidth: 2,
                                        },
                                        {
                                          label: "Boys",
                                          data: data?.month_wise_admission?.map(
                                            (m) => Number(m?.male || 0),
                                          ),
                                          borderColor: "#3b82f6",
                                          backgroundColor:
                                            "rgba(59,130,246,0.08)",
                                          fill: false,
                                          tension: 0.4,
                                          pointRadius: 2,
                                          borderWidth: 1.5,
                                        },
                                        {
                                          label: "Girls",
                                          data: data?.month_wise_admission?.map(
                                            (m) => Number(m?.female || 0),
                                          ),
                                          borderColor: "#ec4899",
                                          backgroundColor:
                                            "rgba(236,72,153,0.08)",
                                          fill: false,
                                          tension: 0.4,
                                          pointRadius: 2,
                                          borderWidth: 1.5,
                                        },
                                      ],
                                    }}
                                    options={{
                                      maintainAspectRatio: false,

                                      interaction: {
                                        mode: "index",
                                        intersect: false,
                                      },

                                      plugins: {
                                        legend: {
                                          position: "top",
                                          labels: {
                                            boxWidth: 10,
                                            padding: 8,
                                          },
                                        },
                                      },

                                      scales: {
                                        x: {
                                          grid: { display: false },
                                          ticks: {
                                            autoSkip: false,
                                            maxRotation: 45,
                                            minRotation: 30,
                                          },
                                        },
                                        y: {
                                          beginAtZero: true,
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row g-3 mt-2">
                            <div className="col-md-12">
                              <div className="card p-3 shadow-sm border-0 h-100">
                                <h6 className="fw-bold mb-3">
                                  📅 Attendance Analytics
                                </h6>

                                {/* 🔷 STATS */}
                                <div className="row text-center mb-1">
                                  <div className="col">
                                    <small>Present</small>
                                    <h5 className="text-success">{present}</h5>
                                  </div>

                                  <div className="col">
                                    <small>Absent</small>
                                    <h5 className="text-danger">{absent}</h5>
                                  </div>

                                  <div className="col">
                                    <small>Low Attendance (3M)</small>
                                    <h5 className="text-warning">{low}</h5>
                                  </div>
                                </div>

                                {/* 🔷 PROGRESS */}
                                {/* <div
                                className="progress mb-3"
                                style={{ height: 8 }}
                              >
                                <div
                                  className="progress-bar bg-success"
                                  style={{ width: `${present}%` }}
                                ></div>
                                <div
                                  className="progress-bar bg-danger"
                                  style={{ width: `${absent}%` }}
                                ></div>
                                <div
                                  className="progress-bar bg-warning"
                                  style={{ width: `${low}%` }}
                                ></div>
                              </div> */}

                                {/* 🔷 GRAPH */}
                                <div style={{ height: 150 }} className="mt-2">
                                  <Bar
                                    data={{
                                      labels: [
                                        "Present",
                                        "Absent",
                                        "Low Attendance (3M)",
                                      ],
                                      datasets: [
                                        {
                                          data: [present, absent, low],
                                          backgroundColor: [
                                            "#22c55e",
                                            "#ef4444",
                                            "#f59e0b",
                                          ],
                                          borderRadius: 6,
                                          barThickness: 30,
                                        },
                                      ],
                                    }}
                                    options={{
                                      maintainAspectRatio: false,
                                      plugins: {
                                        legend: { display: false },
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row g-3">
                            <div className="col-md-12">
                              <div
                                className="card shadow-sm border-0"
                                style={{
                                  borderRadius: "16px",
                                  padding: "16px",
                                }}
                              >
                                <div className="d-flex justify-content-between mb-3">
                                  <h6 className="fw-bold m-0">
                                    🏫 Batch-wise Students
                                  </h6>
                                  <div className="d-flex gap-3 flex-wrap mb-3">
                                    <div className="badge rounded-pill bg-primary p-2">
                                      Total Students : {totalStudents}
                                    </div>

                                    <div className="badge rounded-pill bg-danger p-2">
                                      Boys : {totalBoys}
                                    </div>

                                    <div className="badge rounded-pill bg-info p-2">
                                      Girls : {totalGirls}
                                    </div>
                                  </div>
                                </div>

                                {/* Table View */}
                                <div className="table-responsive mt-4">
                                  <table className="table align-middle table-striped table-sm table-bordered border-primary">
                                    <thead>
                                      <tr>
                                        <th>Batch</th>
                                        <th>Total Students</th>
                                        <th>Boys</th>
                                        <th>Girls</th>
                                        <th>Not Marked</th>
                                      </tr>
                                    </thead>
                                    {/* {JSON.stringify(data)} */}

                                    <tbody>
                                      {data?.batch_wise?.map((batch, index) => (
                                        <tr key={index}>
                                          <td>
                                            <span className="fw-semibold">
                                              {batch?.batch_name}
                                            </span>
                                          </td>

                                          <td>
                                            <span className="badge rounded-pill bg-label-primary">
                                              {batch?.total_student}
                                            </span>
                                          </td>

                                          <td>
                                            <span className="badge rounded-pill bg-label-danger">
                                              {batch?.male}
                                            </span>
                                          </td>

                                          <td>
                                            <span className="badge rounded-pill bg-label-info">
                                              {batch?.female}
                                            </span>
                                          </td>
                                          <td>
                                            <span className="badge rounded-pill bg-label-warning">
                                              {batch?.other ?? 0}
                                            </span>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="filterCanvas">
        {/* HEADER */}
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">Filters</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        {/* BODY */}
        <div className="offcanvas-body">
          <div className="row g-3">
            {/* SESSION */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <select
                  className="form-select"
                  value={filters?.session_id}
                  onChange={(e) =>
                    setFilters({ ...filters, session_id: e.target.value })
                  }
                >
                  <option value="all">All</option>
                  {sessions?.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.session} : {s.status === "1" ? "Active" : "Inactive"}
                    </option>
                  ))}
                </select>
                <label>Session</label>
              </div>
            </div>

            {/* BUTTONS */}
            <div className="row g-2 mt-3">
              <div className="col-6">
                <button
                  className="btn btn-primary w-100"
                  data-bs-dismiss="offcanvas"
                >
                  Apply
                </button>
              </div>

              <div className="col-6">
                <button
                  className="btn btn-outline-danger w-100"
                  onClick={() =>
                    setFilters({
                      session_id: "",
                    })
                  }
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DashboardModal
        setLoading={setLoading}
        allFilter={allFilters}
        setAllFilter={setAllFilters}
      />
    </>
  );
}
